<template>
    <footer>
        <h1><router-link to="/">• listoliby.com</router-link> – Lists to live by</h1>
        <landing-Header v-show="$route.name!='Home'" />

        <nav>
          <router-link to="/">Home</router-link>
          <ul>
            <li></li>
            <li><router-link to="/terms">Terms Of Service</router-link></li>
            <li><router-link to="/privacy">Privacy Policy</router-link></li>
            <li><router-link to="/impressum">Impressum</router-link></li>
          </ul>
      </nav>
    </footer>
</template>

<script>
import LandingHeader from '@/components/landing-header.vue'
export default {
    name: 'FooterStandard',
    components: {
        LandingHeader
    }
}
</script>